module.exports = __webpack_public_path__ + "static/img/logo_3.7885c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_3.png
// module id = +iNW
// module chunks = 0